import React, { useState, useEffect, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Table
} from 'react-bootstrap';

import useUser from '../hooks/useUser';
import CodeSample from '../components/CodeSample';
import Review from '../components/Review';
import GetReviewsAction from '../actions/GetReviewsAction';

export default function ReviewsAlt() {
  const { user } = useUser();

  const [reviewList, setReviewList] = useState("");
  
  useEffect(() => {
    async function fetchReviewList() {
      
      const response = await GetReviewsAction(user.shop.data.saastic_account.data.js_token);

      if(!!response.data) {
          setReviewList(
              response.data.map((i) =>
                <Review key={i.id} reviewData={i} />
              )
          );          
      } else {
          setReviewList(
                <td colspan="5" className="p-2">No reviews yet</td>
          ); 
      }
    }
    fetchReviewList();
  }, []);

  const code_setup = user.shop.data.saastic_account.data.js_token ? `
    <reviews-root></reviews-root>
    <script>
      window.reviews=window.reviews||function(){(reviews.q=reviews.q||[]).push(arguments)};
      window.reviews('init', '`+user.shop.data.saastic_account.data.js_token+`');
    </script>
    <script src="https://tag.saastic.com/js/app.js" async></script>
  ` : '[Unavailable while account is not fully provisioned. Please stand by.]';

  const code_widget = user.shop.data.saastic_account.data.js_token ? `
    <div id="review-wall"></div>
    <script>
      window.reviews('wall', {
        id: 'review-wall',
        score: 3,
        avatar: true,
        date: true,
        border_color: '#ccc',
        border_width: '1px',
        limit: 100
      });
    </script>
  ` : '[Unavailable while account is not fully provisioned. Please stand by.]';


  return (
    <Container fluid className="text-start edit-text">

      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>Click for instructions to embed reviews in your website</Accordion.Header>
          <Accordion.Body>

            <Card>
              <Card.Body>
                <Card.Title>Setup</Card.Title>
                <Card.Text>
                  Paste this just before the <code>&lt;/body&gt;</code> tag
                </Card.Text>
                  <CodeSample
                    codeString={code_setup}
                  />
              </Card.Body>
            </Card>    

            <Card className="mt-3">
              <Card.Body>
                <Card.Title>Review Widget</Card.Title>
                <Card.Text>
                  Paste this in your website code where you want the reviews to display. Reviews are shown as a grid.<br/>
                  Note: only reviews level "Good" and above will be displayed.
                </Card.Text>
                  <CodeSample
                    codeString={code_widget}
                  />
              </Card.Body>
            </Card>    

          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <Table striped bordered hover className="mt-5">
        <thead>
          <tr>
            <th>Customer</th>
            <th>Rating</th>
            <th>Review</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {reviewList}
        </tbody>
      </Table>

    </Container>
  );
}


